import React from 'react';
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';
import ListIcon from '@mui/icons-material/List';

import { TooltipIconButton } from '@paragon/client-tools';
import { SharedComponentSet } from '@paragon/contract-library';
import { getLoggedInUser } from '@paragon/login-tools';

import { showChooseProjectDialog, showSharedComponentSetInfoDialog } from '../../store/actions/popupActions';
import { getProjectLayoutModel } from '../../store/selectors/getProjectLayoutModel';
import { useAppDispatch, useAppSelector } from '../hooks';
import { ContextToolbarContainer, ContextToolbarTitle } from './contextToolbarComponents';

interface Props {
  sharedComponentSet: SharedComponentSet;
}

export function SharedComponentSetContextHeaderToolbar({ sharedComponentSet }: Props) {
  const dispatch = useAppDispatch();
  // If the SharedComponentSet has a ProjectSnapshot, the project layout model will be present
  const projectLayoutModel = useAppSelector(getProjectLayoutModel);
  const loggedInUser = useAppSelector(getLoggedInUser);

  return (
    <ContextToolbarContainer>
      {loggedInUser && (
        <TooltipIconButton
          enableInteractive
          title="Choose Project"
          onClick={() => void dispatch(showChooseProjectDialog())}
        >
          <ListIcon />
        </TooltipIconButton>
      )}

      <ContextToolbarTitle>{sharedComponentSet.name}</ContextToolbarTitle>

      {projectLayoutModel && (
        <TooltipIconButton
          enableInteractive
          title="Shared Component Set Info"
          onClick={() => void dispatch(showSharedComponentSetInfoDialog())}
        >
          <InfoOutlinedIcon />
        </TooltipIconButton>
      )}
    </ContextToolbarContainer>
  );
}
